import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const SyncOperationsViewPage: FC = () => {
  const { syncOperationId } = useParams<{ syncOperationId: Uuid }>();

  if (!syncOperationId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["sync-operation-by-id", syncOperationId],
    queryFn: () =>
      api.get("/internal/v1/sync-operations/{sync_operation_id}", {
        params: {
          path: {
            sync_operation_id: syncOperationId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View SyncOperation</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
